<template>
    <div>
        <mdb-row>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col class="text-center">

                <mdb-row>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                </mdb-row>

                <h2 class="text-secondary">Purchase Balance: {{this.$store.state.userData[0].PurchaseBalance.toFixed(8)}} BTC</h2>
                <span v-if="insufficientFunds" class="font-weight-bold text-danger">Insufficient funds in purchase balance.</span>

                <mdb-row>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">PTP Traffic</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Hits Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Hit</p>
                                    <v-select v-bind:options="ptpValues" v-model="ptpSelected"></v-select>
                                    <mdb-btn v-on:click="buyPTP()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">PTP Traffic</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Time Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Day</p>
                                    <v-select v-bind:options="ptpTimeBasedValues" v-model="ptpTimeBasedSelected"></v-select>
                                    <mdb-btn v-on:click="buyPTPTimeBased()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>

                <mdb-row>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">Banner Impressions</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Hits Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Impression</p>
                                    <v-select v-bind:options="bannerValues" v-model="bannerSelected"></v-select>
                                    <mdb-btn v-on:click="buyBanner()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">Banner Impressions</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Time Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Day</p>
                                    <v-select v-bind:options="bannerTimeBasedValues" v-model="bannerTimeBasedSelected"></v-select>
                                    <mdb-btn v-on:click="buyBannerTimeBased()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>


                <mdb-row>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">Bonus Ad Hits</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Hits Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Impression</p>
                                    <v-select v-bind:options="bonusAdValues" v-model="bonusAdSelected"></v-select>
                                    <mdb-btn v-on:click="buyBonusAd()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                    <mdb-col>
                        <mdb-card border="secondary" class="mb-3 mx-auto" style="max-width: 18rem;">
                            <mdb-card-header class="text-secondary">Bonus Ad Hits</mdb-card-header>
                            <mdb-card-body class="text-secondary">
                                <mdb-card-title tag="h5">Time Based</mdb-card-title>
                                <mdb-card-text>
                                    <p class="text-secondary">1 Credit = 1 Day</p>
                                    <v-select v-bind:options="bonusAdTimeBasedValues" v-model="bonusAdTimeBasedSelected"></v-select>
                                    <mdb-btn v-on:click="buyBonusAdTimeBased()" color="secondary" size="sm">Buy</mdb-btn>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>

            </mdb-col>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col col="1">
            </mdb-col>



        </mdb-row>

        <mdb-row>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
        </mdb-row>

        <button type="button" class="bottomLeftButton" id="bottomLeftButton" onClick="document.getElementById('bottomLeftBanner').remove();this.remove();">x</button>
        <div class="bottomLeftBanner" id="bottomLeftBanner"><square-banner></square-banner></div>

        <button type="button" class="bottomRightButton" id="bottomRightButton" onClick="document.getElementById('bottomRightBanner').remove();this.remove();">x</button>
        <div class="bottomRightBanner" id="bottomRightBanner"><square-banner></square-banner></div>

    </div>
</template>

<script>
    import { mdbRow, mdbCol, mdbBtn, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';

    export default {
        components: { mdbRow, mdbCol, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardHeader },
        data() {
            return {
                recaptchav2SiteKey: this.$store.state.recaptchav2SiteKey,
                recaptchav3SiteKey: this.$store.state.recaptchav3SiteKey,
                address: this.$store.state.userData[0].FaucetHubBitcoinAddress,
                apiResponse: null,
                errorList: null,
                successList: null,
                value: null,
                price: null,
                bonusAdValues: [],
                bonusAdTimeBasedValues: [],
                bannerValues: [],
                bannerTimeBasedValues: [],
                ptpValues: [],
                ptpTimeBasedValues: [],
                bannerSelected: null,
                bannerTimeBasedSelected: null,
                bonusAdTimeBasedSelected: null,
                bonusAdSelected: null,
                ptpSelected: null,
                ptpTimeBasedSelected: null,
                insufficientFunds: false,
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
            }
        },
        methods: {
            test: function () {

            },
            buyBanner: function () {

                if (this.bannerSelected !== null) {

                    if(this.bannerSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.bannerSelected["value"]
                                    }));
                }}
            },
            buyBannerTimeBased: function () {

                if (this.bannerTimeBasedSelected !== null) {

                    if(this.bannerTimeBasedSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.bannerTimeBasedSelected["value"]
                                    }));
                }}
            },
            buyPTP: function () {

                if (this.ptpSelected !== null) {

                    if(this.ptpSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.ptpSelected["value"]
                                    }));
                }}
            },
            buyPTPTimeBased: function () {

                if (this.ptpTimeBasedSelected !== null) {

                    if(this.ptpTimeBasedSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.ptpTimeBasedSelected["value"]
                                    }));
                }}
            },
            buyBonusAd: function () {

                if (this.bonusAdSelected !== null) {

                    if(this.bonusAdSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.bonusAdSelected["value"]
                                    }));
                }}
            },
            buyBonusAdTimeBased: function () {

                if (this.bonusAdTimeBasedSelected !== null) {

                    if(this.bonusAdTimeBasedSelected["price"] > this.$store.state.userData[0].PurchaseBalance)
                    {

                    this.insufficientFunds = true;

                    }
                    else{

                    this.$socket.emit('purchasingAdvertise', JSON.stringify(
                                    {
                                        "sessionId": this.$cookie.get('sessionId'),
                                        "reference": this.ptpTimeBasedSelected["value"]
                                    }));
                }}
            }},
        mounted() {
            this.$store.commit('isLoading', true);
            var values = this.$store.state.advertisePTP;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.ptpValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            values = this.$store.state.advertisePTPTimeBased;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.ptpTimeBasedValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            values = this.$store.state.advertiseBanner;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.bannerValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            values = this.$store.state.advertiseBannerTimeBased;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.bannerTimeBasedValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            values = this.$store.state.advertiseBonusAd;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.bonusAdValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            values = this.$store.state.advertiseBonusAdTimeBased;

            for (var i = 0; i < Object.keys(values).length; i++) {

                this.bonusAdTimeBasedValues.push({label: `${values[i].Credit} Credits - ${values[i].Price.toFixed(8)} BTC`, value: values[i].Reference, price: values[i].Price.toFixed(8)});
            }

            
            

            
            
            
            
            
            
            
            
            
            
            
            

            
            

            this.$store.commit('isLoading', false);

        }
    }


</script>